import { convertTagPageId } from '../../convertTagPageId';

/**
 * @param {String} pageTagType
 * @param {String} pageTagId
 * @returns {String}
 */
export const getIdeaPageName = (pageTagType, pageTagId) =>
    `logo_maker_${convertTagPageId(pageTagType)}_${convertTagPageId(pageTagId)}`;
